import { updateBarData } from "@/mocks/home";

export default function UpdateBar() {
  const tickerText = updateBarData.ticker.join("     ·     ");

  return (
    <div className="sticky top-0 z-50 w-full bg-accent-950 text-background-50">
      <div className="mx-auto flex h-11 w-full items-center gap-4 px-4 md:px-8">
        <div className="flex shrink-0 items-center gap-2">
          <span className="relative flex h-2 w-2 items-center justify-center">
            <span className="absolute inline-flex h-2 w-2 rounded-full bg-primary-400 animate-soft-pulse"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
          </span>
          <span className="font-label text-xs tracking-[0.2em] text-background-100 md:text-sm">
            {updateBarData.brand}
          </span>
        </div>

        <div className="hidden min-w-0 flex-1 overflow-hidden md:block">
          <div className="flex w-max animate-marquee whitespace-nowrap">
            <span className="px-6 text-xs text-background-300">{tickerText}</span>
            <span className="px-6 text-xs text-background-300">{tickerText}</span>
          </div>
        </div>

        <div className="ml-auto flex shrink-0 items-center gap-2 text-xs md:text-sm">
          <i className="ri-shield-check-line text-primary-400"></i>
          <span className="hidden text-background-300 sm:inline">最近校验 {updateBarData.checkedAt}</span>
          <span className="text-background-200">在线入口</span>
          <span className="font-semibold text-background-50">
            {updateBarData.online}/{updateBarData.total}
          </span>
        </div>
      </div>
    </div>
  );
}